import { marketplaceApiVersionPrefix } from '../client'

export function productVariantIdToIri(productVariantId: string) {
  return `${marketplaceApiVersionPrefix}/shop/product-variants/${productVariantId}`
}
